import React from 'react';
import './styles/App.css';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import { Route, Routes } from 'react-router-dom';
// import { ErrorBoundary } from 'react-error-boundary';

function App() {
  return (
    // <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="App">
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/freeweight" element={<SignIn />} />
          <Route path="/home/*" element={<Home />} />
          <Route path="*" element={<SignIn />} />
        </Routes>
      </div>
    // </ErrorBoundary>
  );
}

export default App;
